import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

const PathsSection = () => {
  const [active, setActive] = useState("job");

  const toggleActive = (path) => {
    setActive(active === path ? "" : path);
  };

  const accordionItems = [
    {
      id: "job",
      title: "Job Roles Path",
      desc: "Guide your employees towards a specific cybersecurity role or function.",
    },
    {
      id: "skill",
      title: "Skill Paths",
      desc: "Develop focused technical expertise across specialized areas.",
    },
    {
      id: "custom",
      title: "Custom Paths",
      desc: "Build unique learning experiences tailored to your team’s needs.",
    },
  ];

  return (
    <div className="bg-gradient-to-br from-red-700 to-blue-800 text-white p-6 md:p-12 lg:p-20 font-sans">
      {/* Heading */}
      <h2 className="text-center text-2xl md:text-3xl lg:text-4xl font-bold mb-10">
        Breeze through team and content management
      </h2>

      {/* Path-Based Learning */}
      <div className="flex flex-col lg:flex-row gap-6 mb-12">
        {/* Left Side (Tabs) */}
        <motion.div
          initial={{ opacity: 0, x: -50 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.6 }}
          className="flex flex-col gap-4 bg-black/30 p-6 rounded-xl text-xl font-bold min-w-[250px]"
        >
          {accordionItems.map((item) => (
            <button
              key={item.id}
              className={`text-left transition-colors duration-300 ${
                active === item.id ? "text-green-400" : "text-gray-300"
              }`}
              onClick={() => toggleActive(item.id)}
            >
              {item.title}
            </button>
          ))}
        </motion.div>

        {/* Right Side (Accordion) */}
        <div className="flex-1 min-w-[300px] bg-black/30 p-6 rounded-xl">
          <h3 className="text-xl font-bold mb-2">Path-Based Learning</h3>
          <p className="text-gray-300 text-sm mb-4">
            Guide your team towards the right learning path.
          </p>

          {accordionItems.map((item) => (
            <div
              key={item.id}
              className="border-b border-gray-600 py-3 cursor-pointer"
              onClick={() => toggleActive(item.id)}
            >
              <div
                className={`flex justify-between items-center font-medium transition-colors duration-300 ${
                  active === item.id ? "text-green-400 font-bold" : "text-white"
                }`}
              >
                <span>{item.title}</span>
                <span>{active === item.id ? "−" : "+"}</span>
              </div>
              <AnimatePresence>
                {active === item.id && (
                  <motion.p
                    initial={{ opacity: 0, height: 0 }}
                    animate={{ opacity: 1, height: "auto" }}
                    exit={{ opacity: 0, height: 0 }}
                    transition={{ duration: 0.3 }}
                    className="text-gray-300 text-sm mt-2"
                  >
                    {item.desc}
                  </motion.p>
                )}
              </AnimatePresence>
            </div>
          ))}
        </div>
      </div>

      {/* Bottom Cards */}
      <div className="flex flex-col md:flex-row gap-6 justify-center">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="flex-1 min-w-[250px] bg-black/30 p-6 rounded-xl text-center"
        >
          <div className="text-3xl mb-2">👥</div>
          <h4 className="font-bold mb-1">User seat flexibility</h4>
          <p className="text-gray-300 text-sm">
            Invite employees and assign user seats.
          </p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
          className="flex-1 min-w-[250px] bg-black/30 p-6 rounded-xl text-center"
        >
          <div className="text-3xl mb-2">📊</div>
          <h4 className="font-bold mb-1">Any skill level</h4>
          <p className="text-gray-300 text-sm">
            From easy to hard modules for your employees.
          </p>
        </motion.div>
      </div>
    </div>
  );
};

export default PathsSection;